import brandDomains from "./hostConfig";
import config from './config'

//Adding keys here as this is client side brand specific rendering
const KEYS = {
    31: {
        bucket: "yolosite",
        key: "al5nn1XT40WKQsBRnnuljAxGa2KrkVxBMl8QwyQATWjd9E6VuC"
    },
    32: {
        bucket: 'yolosite',
        key: 'al5nn1XT40WKQsBRnnuljAxGa2KrkVxBMl8QwyQATWjd9E6VuC'
    },
    33: {
        bucket: 'iw247-prodcution',
        key: 'YlJ1iLM53xDz7ADzTntvLc3H6OEYcblzYVqnHhHYnkUkFfIhyf'
    },
    34: {
        bucket: 'iw247-prodcution',
        key: 'YlJ1iLM53xDz7ADzTntvLc3H6OEYcblzYVqnHhHYnkUkFfIhyf'
    },
    39: {
        bucket: 'fomo7-production',
        key: 'iXIt81kkqM6cnBoq8319KQ5hDOsizqBJi58go4uBPH8GtZ6etK'
    },
    40: {
        bucket: 'fomo7-production',
        key: 'iXIt81kkqM6cnBoq8319KQ5hDOsizqBJi58go4uBPH8GtZ6etK'
    },
    46: {
        bucket: 'fun88-production',
        key: 'O09rOlg3aQ0ABlz47OxDxaiRrEMJiYls10fTM8k73zbBZC9oMb'
    },
    47: {
        bucket: 'fun88-production',
        key: 'O09rOlg3aQ0ABlz47OxDxaiRrEMJiYls10fTM8k73zbBZC9oMb'
    },
    61: {
        bucket: 'cms-integration-production-a57f4ae0-4c21-11f0-8eb8-e58dbeebc24f',
        key: 'pb1MHE3qpISbIWd8SrqrSoa8dfDPbk6JXnSgMv6xwpTOR1BcA2'
    },
}

const getHostInfo = () => {
    try {
        const _location = window.location;
        const _host = _location.host;
        const currDomain: any = brandDomains.find(obj => obj.domain === _host) || {
            brandId: 31,
            main: false
        };
        return ({
            brandId: currDomain.id,
            main: currDomain.main,
            path:_location.pathname
        })


    } catch (error) {
        return ({
            brandId: 31,
            main: false,
            path:window.location.pathname
        });

    }
}

const metaForBackupSite = (url: string,canonical?:string ): Promise<any> => {
    const defObj = {
        "pathname": "",
        "no_indexindex": true,
        "no_followfollow": null,
        "meta-title": null,
        "meta-description": null,
        "canonical": null,
        "tag_manager_head_code": null,
        "tag_manager_body_code": null,
        "alternates_(alternate_-_media_only)": null,
        "hreflang_(en)": null,
        "hreflang_(hi)": null,
        "hreflang_(te)": null,
        "og_url": null,
        "og_title": null,
        "og_description": null,
        "og_type": null,
        "og_image": null,
        "og_site_name": null,
        "og_locale": null,
        "twitter_card": null,
        "twitter_title": null,
        "twitter_description": null,
        "twitter_image": null,
        "twitter_url": null,
        "twitter_site": null,
        "twitter_creator": null,
        "breadcrumb_schema": null,
        "webpage_schema": null,
        "article_schema": null,
        "faq_schema": null,
        "game_schema": null,
        "app_schema": null,
        "review_schema": null,
        "organization_schema": null,
        "navigation_schema": null,
        "how_to_schema": null,
        "seo_footer_title_(h1)": null,
        "seo_footer_content": null
    }

    //Return a new Promise. The executor function (resolve, reject) runs immediately.
    const canonicalURL = canonical ? canonical : url;
    return new Promise((resolve, reject) => {

        const obj = {
            objects: [{
                metadata: {
                    ...defObj,
                    "pathname": url,
                    "canonical": canonicalURL,
                    "alternates_(alternate_-_media_only)": canonicalURL,
                }
            }
            ]
        };

        // Resolve the Promise with the generated object.
        resolve(obj);

        // Note: I removed the `async` keyword from the function signature 
        // because we are explicitly returning `new Promise`.
    });
};

const getKey = () => {
    let obj = {
        bucket: "",
        key: ""
    }

    if (typeof window.location === 'object') {
        const { brandId } = getHostInfo();
        const keys = KEYS[brandId];
        return keys || obj;
    }

    return obj;
}

// const getURL_old = (query: string, props: string, page?: string) => {
//     const { bucket, key } = getKey();

//     if (!bucket || !key) {
//         return;
//     }

//     const url = `${config.cmsAPI}/v3/buckets/${bucket}/objects?pretty=true&query=${query}&skip=0&read_key=${key}&depth=1&props=${props},`;

//     return url;
// }

const getData = async (url: string) => {
    try {
        const resp = await fetch(url, { cache: 'force-cache' })
        if (!resp.ok) {
            throw new Error(`Response status: ${resp.status}`);
        }

        const respJson = await resp.json();
        return respJson;

    } catch (error) {
        console.error(error.Message);

    }

    return {}

}

//Integrating cache for CMS
//New keys are required to call the new API

const getAPIKeys = () => {
    let retObj = {
        bucket: "",
        key: "",
        brand: 31
    }

    if (typeof window.location === 'object') {
        const _path = window.location.host;

        if (_path) {
            const { brandId } = getHostInfo();
            const keys = KEYS[brandId] || { key: "", bucket: "" };
            return {
                bucket: keys.bucket,
                key: keys.key,
                brand: brandId,
            }
        }
    }

    return retObj

}

const getNewURL = (query: string, props: string, page: string) => {
    const { bucket, key, brand } = getAPIKeys();

    // if (!bucket || !key) {
    //     return "";
    // }

    const url = `
    ${config.cmsAPI}/default/cms-function?page=${page}&brand=${brand}&language=en&query=${query}&props=${props}`;

    return url;
}

const isClubsite = (brandId: any) => {
    let retV = {
        isClub: false,
        domainURL: ''
    };

    try {
        const clubBrands = [32, 46, 34, 40];
        let isClub = clubBrands.includes(brandId);
        if (isClub) {
            const mainBrands = {
                32: 31,
                46: 47,
                34: 33,
                40: 39
            };

            const canonicalBrand = mainBrands[brandId];
            const currDomain: any = brandDomains.find(obj => obj.id === canonicalBrand && obj.main === true) || {};
            const domainURL = currDomain.domain ? `https://${currDomain.domain}` : '';
            return {
                isClub: isClub,
                domainURL: domainURL
            }
        }

        return retV

    } catch (error) {
        return retV;

    }
};


//API DATA
export const homePageSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();

    if (!main) {
        const response = await metaForBackupSite("/");
        return response
    }
    else {
        //NEW CHANGES FOR CLUB
        let APIURL = '%7B%22type%22:%22homepage-mobiles%22%7D&limit=210';
        if(brandId && (brandId == 32 || brandId == 46 || brandId == 40)) {
            APIURL = '%7B%22type%22:%22club-homepage%22%7D&limit=10';
        }
        const url = getNewURL(APIURL, 'slug,title,metadata,type', 'homepage');
        const response = await getData(url);
        return response;
    }
}

export const liveCasinosSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();
    const {isClub, domainURL} = isClubsite(brandId);
   
    if (!main || isClub) {
        const canonical = domainURL? `${domainURL}${path}` : path;
        const response = await metaForBackupSite(path,canonical);
        return response
    }
    else {
        const url = getNewURL('%7B%22type%22:%22live-casino-mobiles%22%7D&limit=1000', 'slug,title,metadata,type', 'live-casino');
        const response = await getData(url);

        return response;
    }
}

export const instantGamesSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();
    const {isClub, domainURL} = isClubsite(brandId);
   
    if (!main || isClub) {
        const canonical = domainURL? `${domainURL}${path}` : path;
        const response = await metaForBackupSite(path,canonical);
        return response
    }
    else {
        const url = getNewURL('%7B%22type%22:%22instant-games-mobile%22%7D&limit=1000', 'slug,title,metadata,type', 'instant-games');
        const response = await getData(url);
        return response;
    }
}

export const slotsGamesSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();
   const {isClub, domainURL} = isClubsite(brandId);
   
    if (!main || isClub) {
        const canonical = domainURL? `${domainURL}${path}` : path;
        const response = await metaForBackupSite(path,canonical);
        return response
    }
    else {
        const url = getNewURL('%7B%22type%22:%22slots-mobiles%22%7D&limit=1000', 'slug,title,metadata,type', 'slots');
        const response = await getData(url);
        return response;
    }
}

export const sportsGamesSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();
    if (!main) {
        const response = await metaForBackupSite(path);
        return response
    }
    else {
        let APIURL = '%7B%22type%22:%22sports-mobiles%22%7D&limit=300';
        if(brandId && (brandId == 32 || brandId == 46 || brandId == 40)) {
            APIURL = '%7B%22type%22:%22club-sports%22%7D&limit=300';
        }
        const url = getNewURL(APIURL, 'slug,title,metadata,type', 'sports');
        const response = await getData(url);
        return response;
    }
}

export const otherPagesSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();
    const {isClub, domainURL} = isClubsite(brandId);
   
    if (!main || isClub) {
        const canonical = domainURL? `${domainURL}${path}` : path;
        const response = await metaForBackupSite(path,canonical);
        return response
    }
    else {
        const url = getNewURL('%7B%22type%22:%22other-pages-mobiles%22%7D&limit=210', 'slug,title,metadata,type', 'other-pages');
        const response = await getData(url);
        return response;
    }
}

export const bonusPagesSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();
   const {isClub, domainURL} = isClubsite(brandId);
   
    if (!main || isClub) {
        const canonical = domainURL? `${domainURL}${path}` : path;
        const response = await metaForBackupSite(path,canonical);
        return response
    }
    else {
        const url = getNewURL('%7B%22type%22:%22bonus-pages-mobiles%22%7D&limit=210', 'slug,title,metadata,type', 'bonus-pages');
        const response = await getData(url);
        return response;
    }
}

export const authPagesSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();
   const {isClub, domainURL} = isClubsite(brandId);
   
    if (!main || isClub) {
        const canonical = domainURL? `${domainURL}${path}` : path;
        const response = await metaForBackupSite(path,canonical);
        return response
    }
    else {
        const url = getNewURL('%7B%22type%22:%22auth-pages-mobiles%22%7D&limit=210', 'slug,title,metadata,type', 'auth-pages');
        const response = await getData(url);
        return response;
    }
}

export const tncPagesSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();
   const {isClub, domainURL} = isClubsite(brandId);
   
    if (!main || isClub) {
        const canonical = domainURL? `${domainURL}${path}` : path;
        const response = await metaForBackupSite(path,canonical);
        return response
    }
    else {
        const url = getNewURL('%7B%22type%22:%22tnc-page-mobiles%22%7D&limit=210', 'slug,title,metadata,type', 'tnc-page');
        const response = await getData(url);
        return response;
    }
}

export const otherGamePagesSEOData = async () => {
    const _hostInfo = getHostInfo();
    const { brandId, main, path } = getHostInfo();
   const {isClub, domainURL} = isClubsite(brandId);
   
    if (!main || isClub) {
        const canonical = domainURL? `${domainURL}${path}` : path;
        const response = await metaForBackupSite(path,canonical);
        return response
    }
    else {
        const url = getNewURL('%7B%22type%22:%22other-game-page-mobiles%22%7D&limit=210', 'slug,title,metadata,type', 'other-game-page');
        const response = await getData(url);
        return response;
    }
}